import { Location } from "react-router-dom";
// helpers
import { mockOfferCodeKeyword, mockCategoriesKeyword } from "../../../pages/Explore/helpers/constant";
import { buildAirportBusBreadcrumbEntries } from "../../../pages/PublicTransport/AirportBus/helpers/buildAirportBusBreadcrumbEntries";
import {
  DEUTSCHE_BAHN_DISPLAY_NAME,
  DEUTSCHE_BAHN_PATH_SUFFIX
} from "../../../pages/PublicTransport/DeutscheBahn/constants";
// types
import { CrumbsType } from "../types";

export const getOfferCode = (location: Location): string | undefined =>
  location?.pathname?.split("offers/")?.pop()?.split("/")[0];

export const getBreadcrumbs = (
  location: Location,
  hotelName: string,
  offerName: string,
  searchedQuery: string,
  categories: any,
  searchResultLabel: string,
  categoryResultLabel: string,
  checkoutLabel: string,
  confirmationLabel: string,
  airportBusOfferName?: string
): Array<CrumbsType> => {
  const offerCode = getOfferCode(location);
  const keywordHref = `?${mockOfferCodeKeyword?.toLowerCase()}=${searchedQuery}`;

  const selectedCategories = categories
    ?.filter((category: any) => category.selected) // Only take the categories that are selected (true)
    ?.map((category: any) => category.value);

  const categoriesHref =
    searchedQuery?.length === 0 && location?.pathname !== "/" && categories?.length > 0
      ? `?${mockCategoriesKeyword?.toLowerCase()}=${encodeURIComponent(selectedCategories)}`
      : `&${mockCategoriesKeyword?.toLowerCase()}=${encodeURIComponent(selectedCategories)}`;

  const language = localStorage.getItem("i18nextLng");

  const allBreadcrumbs: Array<CrumbsType> = [
    {
      href: `/${language}`,
      show: true,
      name: hotelName
    },
    {
      href: `/${language}${categoriesHref}`,
      show: searchedQuery?.length === 0 && location?.pathname !== "/" && selectedCategories?.length > 0,
      name: categoryResultLabel
    },
    {
      href: `/${language}${keywordHref}${selectedCategories?.length > 0 ? categoriesHref : ""}`,
      show: location?.search?.includes(keywordHref),
      name: searchedQuery
    },
    {
      href: `/${language}${keywordHref}${selectedCategories?.length > 0 ? categoriesHref : ""}`,
      show: searchedQuery?.length > 0 && location?.pathname !== "/",
      name: searchResultLabel
    },
    {
      href: `/${language}/offers/${offerCode}`,
      show: location?.pathname?.includes(`/offers/${offerCode}`),
      name: offerName
    },
    {
      href: `/${language}/offers/${offerCode}/checkout`,
      show: location?.pathname?.includes(`/offers/${offerCode}/checkout`),
      name: checkoutLabel
    },
    {
      href: `/${language}/offers/${offerCode}/checkout/confirmation`,
      show: location?.pathname?.includes(`/offers/${offerCode}/checkout/confirmation`),
      name: confirmationLabel
    },
    {
      href: `/${language}/transport/sbb`,
      show: location?.pathname?.includes(`/transport/sbb`),
      name: "SBB"
    },
    {
      href: `/${language}/transport/swiss_travel_pass`,
      show: location?.pathname?.includes(`/transport/swiss_travel_pass`),
      name: "Swiss Travel Pass"
    },
    {
      href: `/${language}/transport/swiss_travel_pass/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/swiss_travel_pass/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/munich-city-pass`,
      show: location?.pathname?.includes(`/transport/munich-city-pass`),
      name: "Munich City Pass"
    },
    {
      href: `/${language}/transport/munich-city-pass/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/munich-city-pass/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/frankfurt-card`,
      show: location?.pathname?.includes(`/transport/frankfurt-card`),
      name: "Frankfurt Card"
    },
    {
      href: `/${language}/transport/frankfurt-card/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/frankfurt-card/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/uber`,
      show: location?.pathname?.includes(`/transport/uber`),
      name: "UBER"
    },
    {
      href: `/${language}/transport/airport-taxi`,
      show: location?.pathname?.includes(`/transport/airport-taxi`),
      name: "Airport Taxi"
    },
    {
      href: `/${language}/transport/europcar`,
      show: location?.pathname?.includes(`/transport/europcar`),
      name: "Europcar"
    },
    {
      href: `/${language}/transport/zurich_card`,
      show: location?.pathname?.includes(`/transport/zurich_card`),
      name: "Zürich Card"
    },
    {
      href: `/${language}/transport/zurich_card/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/zurich_card/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/sbb/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/sbb/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/cat`,
      show: location?.pathname?.includes(`/transport/cat`),
      name: "CAT"
    },
    {
      href: `/${language}/transport/cat/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/cat/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/limos4`,
      show: location?.pathname?.includes(`/transport/limos4`),
      name: "Limos4"
    },
    {
      href: `/${language}/transport/limos4/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/limos4/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}/transport/obb`,
      show: location?.pathname?.includes(`/transport/obb`),
      name: "ÖBB"
    },
    {
      href: `/${language}/transport/obb/confirmation`,
      show: location?.pathname?.includes(`/${language}/transport/obb/confirmation`),
      name: "Confirmation"
    },
    {
      href: `/${language}${DEUTSCHE_BAHN_PATH_SUFFIX}`,
      show: location?.pathname?.includes(DEUTSCHE_BAHN_PATH_SUFFIX),
      name: DEUTSCHE_BAHN_DISPLAY_NAME
    },
    {
      href: `/${language}${DEUTSCHE_BAHN_PATH_SUFFIX}/confirmation`,
      show: location?.pathname?.includes(`/${language}${DEUTSCHE_BAHN_PATH_SUFFIX}/confirmation`),
      name: "Confirmation"
    },
    ...buildAirportBusBreadcrumbEntries({
      language,
      pathname: location?.pathname || "",
      airportBusOfferName
    })
  ];

  // filter only active breadcrumbs
  return allBreadcrumbs?.filter(crumb => crumb?.show);
};
